/**
 * Que formas de entrega ofrece hoy la tienda, para las pantallas que la
 * anuncian: la barra de la cabecera, la portada, la ficha, el carro y el
 * checkout.
 *
 * La regla NO se decide aca: la resuelve el backend a partir de lo que el panel
 * dejo encendido y la manda lista en `OpcionesDespacho.entregas`. Estas
 * funciones solo la leen, para que ninguna pantalla prometa "despacho gratis"
 * el dia en que el despacho esta apagado.
 *
 * Mientras las opciones no llegan (`null`) todas responden que no: es mejor no
 * anunciar un despacho por un instante que anunciarlo cuando no existe.
 */
import type { OpcionesDespacho, TipoEntrega } from '@bandu/compartido';

export function ofreceDespacho(opciones: OpcionesDespacho | null): boolean {
  return opciones !== null && opciones.entregas.includes('despacho');
}

export function ofreceRetiro(opciones: OpcionesDespacho | null): boolean {
  return opciones !== null && opciones.entregas.includes('retiro');
}

/** Ni despacho ni retiro: la entrega se acuerda por telefono despues de pagar. */
export function soloCoordinar(opciones: OpcionesDespacho | null): boolean {
  return opciones !== null && opciones.entregas.includes('coordinar');
}

/**
 * La entrega que vale para el formulario: la elegida si se sigue ofreciendo, y
 * si no, la primera que se ofrece. Cubre al comprador que vuelve con un checkout
 * guardado cuando el panel ya apago lo que habia elegido.
 */
export function entregaVigente(elegida: TipoEntrega, opciones: OpcionesDespacho | null): TipoEntrega {
  if (opciones === null || opciones.entregas.includes(elegida)) return elegida;
  return opciones.entregas[0] ?? elegida;
}

/**
 * Como termina una meta descripcion segun la entrega que se ofrece hoy. Un
 * buscador guarda la descripcion por semanas: con el despacho apagado no puede
 * seguir diciendo "despacho a todo Chile". Sin opciones todavia, nada.
 */
export function anuncioEntrega(opciones: OpcionesDespacho | null): string {
  if (ofreceDespacho(opciones)) return ' y despacho a todo Chile';
  if (ofreceRetiro(opciones)) return ' y retiro en nuestra tienda de Pucón';
  return '';
}

/** Como se nombra cada entrega donde se lista un pedido: panel, resumen. */
export function textoEntrega(tipo: TipoEntrega): string {
  switch (tipo) {
    case 'despacho':
      return 'Despacho a domicilio';
    case 'retiro':
      return 'Retiro en tienda';
    case 'coordinar':
      return 'Entrega por coordinar';
  }
}
